import classNames from 'classnames/bind';
import Link from 'next/link';
import { TripType } from 'types/apollo';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface Props {
  tripType: TripType;
  onClose(): void;
}

export default function SubscriptionLimitAlert({ tripType, onClose }: Props) {
  return (
    <div className={cx('SubscriptionLimitAlert')}>
      <div className={cx('modal')}>
        <div className={cx('content')}>
          <h5 className={cx('title')}>
            더 이상 가격 변동 알림을
            <br />
            추가할 수 없습니다
          </h5>
          <p className={cx('text')}>
            알림 설정은 노선 최대 10개,
            <br />
            노선 당 최대 4개까지 가능합니다.
            <br />
            해당 알림을 추가하고 싶을 경우에는 현재 설정된 알림 중 1개 이상
            삭제해야 합니다.
          </p>
          <div className={cx('btns')}>
            <button
              type="button"
              className={cx('cancel')}
              onClick={onClose}
              data-event-nlog="click"
              data-event-area-code={`${tripType === TripType.Ow ? 'lon' : 'lrd'}.noadd`}
            >
              확인
            </button>
            <Link
              className={cx('more')}
              href="/price-alerts"
              data-event-nlog="click"
              data-event-area-code={`${tripType === TripType.Ow ? 'lon' : 'lrd'}.primanage`}
            >
              알림 설정 관리
            </Link>
          </div>
          <button
            type="button"
            className={cx('close')}
            onClick={onClose}
            aria-label="닫기"
            data-event-nlog="click"
            data-event-area-code={`${tripType === TripType.Ow ? 'lon' : 'lrd'}.priclose`}
          />
        </div>
      </div>
    </div>
  );
}
